var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOcrUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/ocr-upload"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1006 5.40015V13.5001C17.1006 14.9913 18.3094 16.2001 19.8006 16.2001H27.9006V27.9001C27.9006 29.3913 26.6918 30.6001 25.2006 30.6001H10.8006C9.30942 30.6001 8.10059 29.3913 8.10059 27.9001V8.10015C8.10059 6.60898 9.30942 5.40015 10.8006 5.40015H17.1006Z",
    fill: "#ADCCF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9006 5.85015V13.5001C18.9006 13.9972 19.3035 14.4001 19.8006 14.4001H27.4506L18.9006 5.85015Z",
    fill: "#ADCCF3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 0C0.671573 0 0 0.671573 0 1.5V7.5C0 8.32843 0.671573 9 1.5 9C2.32843 9 3 8.32843 3 7.5V3H7.5C8.32843 3 9 2.32843 9 1.5C9 0.671573 8.32843 0 7.5 0H1.5ZM1.5 36C0.671573 36 0 35.3284 0 34.5V28.5C0 27.6716 0.671573 27 1.5 27C2.32843 27 3 27.6716 3 28.5V33H7.5C8.32843 33 9 33.6716 9 34.5C9 35.3284 8.32843 36 7.5 36H1.5ZM36 1.5C36 0.671573 35.3284 0 34.5 0H28.5C27.6716 0 27 0.671573 27 1.5C27 2.32843 27.6716 3 28.5 3H33V7.5C33 8.32843 33.6716 9 34.5 9C35.3284 9 36 8.32843 36 7.5V1.5ZM34.5 36C35.3284 36 36 35.3284 36 34.5V28.5C36 27.6716 35.3284 27 34.5 27C33.6716 27 33 27.6716 33 28.5V33H28.5C27.6716 33 27 33.6716 27 34.5C27 35.3284 27.6716 36 28.5 36H34.5Z",
    fill: "#61A3EF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcrUpload);
export default __webpack_public_path__ + "static/media/ocr-upload.faa6c46af996c6a8377c7b539717ae29.svg";
export { ForwardRef as ReactComponent };